import Image from "next/image";
import { MdArrowOutward } from "react-icons/md";
import { knowledgeHubList } from "./constant";
const NavKnowledgeHubMenu: React.FC = () => {
    return (
        <section className="w-full mx-auto px-8 bg-white py-10">
            <div className="grid grid-cols-4 gap-10 max-w-7xl mx-auto px-5">
                {knowledgeHubList.map((value) => {
                    const isBlog = value.featureTitle === "Blogs";
                    return (
                        <div key={value.featureTitle} className={isBlog ? "col-span-3" : ""}>
                            <div className="font-bold text-xl uppercase pb-5">{value.featureTitle}</div>
                            {/* <hr className={`${isBlog ? "w-64 pt-3" : "w-64 pt-3"} border border-gray-300`} /> */}
                            <hr style={{ borderTop: "1px solid #CBD5E0" }} className="pt-3" />
                            <div className={`${isBlog ? "bg-[#F1F4FF] grid grid-cols-2 gap-10 rounded-lg" : "space-y-5"}`}>
                                {value.feature.map((data, index) => (
                                    <div className="flex gap-5 cursor-pointer" key={index}>
                                        {data.image && <Image alt={data.imgAlt ?? ""} src={data.image ?? ""} width={160} height={160} className="pb-3" />}
                                        <div className="font-semibold text-sm pb-2 flex flex-col">
                                            {data.title && <a href={data.link}>{data.title}</a>}
                                            {data.summary && (
                                                <a href={data.link} className="text-sm font-semibold">
                                                    {data.summary}
                                                </a>
                                            )}
                                        </div>
                                    </div>
                                ))}
                                {isBlog && (
                                    <a href="/blog" className="text-[#3364FA] text-base font-medium flex items-center gap-2">
                                        Explore all articles
                                        <MdArrowOutward size={20} />
                                    </a>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        </section>
    );
};

export default NavKnowledgeHubMenu;
